import {kSystemIcons} from "../../../constants/icons";
import {isNullOrUndefined} from "../../../services/Validator";

export default function BrevetLevelAHeaderTitleButton({title, justifyStart, isCurrentSort, isDesc, onSortPressed}) {
    // Used in

    // BUILD
    return (
        <div className={`flex ${justifyStart ? "justify-start space-x-[6px]" : "justify-end"} ${!isNullOrUndefined(onSortPressed) ? "cursor-pointer" : "cursor-auto"}`}
             onClick={onSortPressed}>
            <span className={"font-bold text-[14px] text-white whitespace-nowrap"}>
                {title}
            </span>
            {onSortPressed && (
                <div className={`mt-[1px] w-[20px] min-w-[20px] h-[20px] min-h-[20px] rounded-[6px] ${isCurrentSort ? "bg-greenStar/30 text-greenStar" : "bg-transparent text-greyLight7"} flex justify-center items-center`}>
                    <i className={"material-icons text-[12px] select-none"}>
                        {!isCurrentSort
                            ? kSystemIcons.arrowDouble
                            : isDesc ? kSystemIcons.arrowDown : kSystemIcons.arrowUp}
                    </i>
                </div>
            )}
        </div>
    );
}